<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="btnclick" :pageData="pageData"></table-page>
    <!-- Comment Dialog -->
    <Dialog ref="childDialog" :dialogData="dialogData" :title="dialogTitle"></Dialog>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../../components/page/table.vue'
    import FORM from '../../components/page/form.vue'
    import Dialog from './dialog.vue'

    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import AUTH from '@/views/mis/util/auth'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'

    const requestOptions = {
	    headers: {"Content-Type": "application/json"},
        responseType: "blob",
    }
    const cascaderProps = {
        expandTrigger: 'hover',
        multiple: true, 
        collapse: true, 
        emitPath: false,
    }

    const accountTypeOptionList = [
        {key: 0, value: window.$t("mis.feedback.queryForm.option.accountType.all")},
        {key: 1, value: window.$t("mis.feedback.queryForm.option.accountType.visitor")},
        {key: 2, value: window.$t("mis.feedback.queryForm.option.accountType.demoAccount")},
        {key: 3, value: window.$t("mis.feedback.queryForm.option.accountType.realAccount")},
    ];
    const contactOptionList = [
        {key: 0, value: window.$t("mis.feedback.queryForm.option.contact.any")},
        {key: 1, value: window.$t("mis.feedback.queryForm.option.contact.phone")},
        {key: 2, value: window.$t("mis.feedback.queryForm.option.contact.wechat")}
    ];
    const imageOptionList = [
        {key: 0, value: window.$t("mis.feedback.queryForm.option.image.any")},
        {key: 1, value: window.$t("mis.feedback.queryForm.option.image.has")},
        {key: 2, value: window.$t("mis.feedback.queryForm.option.image.no")}
    ];
    const validateStatusOptionList = [
        {key: 0, value: window.$t("mis.feedback.queryForm.option.validateStatus.any")},
        {key: 1, value: window.$t("mis.feedback.queryForm.option.validateStatus.valid")},
        {key: 2, value: window.$t("mis.feedback.queryForm.option.validateStatus.invalid")}
    ];
    const accountStatusOptionList = [
        {key: 0, value: window.$t("mis.feedback.queryForm.option.accountStatus.any")},
        {key: 1, value: window.$t("mis.feedback.queryForm.option.accountStatus.test")},
        {key: 2, value: window.$t("mis.feedback.queryForm.option.accountStatus.real")}
    ];
    const platformOptionList = [
        {key: 0, value: window.$t("mis.feedback.queryForm.option.platform.any")},
        {key: 1, value: window.$t("mis.feedback.queryForm.option.platform.app")},
        {key: 2, value: window.$t("mis.feedback.queryForm.option.platform.mobile")},
        {key: 3, value: window.$t("mis.feedback.queryForm.option.platform.pc")},
    ];
    const fixedChannelOptions = [
        {
            children:[
                {label:"CF138", value:-1},
                {label:"CF139", value:-2}
            ],
            label: "M端",
            value: "Mobile"
        },
        {
            children:[
                {label:"CF138", value:-3},
                {label:"CF139", value:-4}
            ],
            label: "PC",
            value: "PC"
        },
    ];
    const fixedChannelMasterList = [
        {id: -1, name: "CF138", channel: "Mobile", createdBy: null, updatedBy: null},
        {id: -2, name: "CF139", channel: "Mobile", createdBy: null, updatedBy: null},
        {id: -3, name: "CF138", channel: "PC", createdBy: null, updatedBy: null},
        {id: -4, name: "CF139", channel: "PC", createdBy: null, updatedBy: null},
    ];

    let channelOptionList=[];//广告渠道及渠道app
    let channelAppMasterList=[]; //广告渠道app总List

    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            Dialog
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('mis.feedback.queryForm.button.query') == clickName){
                    if(data) {
                        // console.log("Form data", data);
                        this.queryData.accountType = data.accountType ? data.accountType : 0;
                        this.queryData.realAccount = data.realAccount ? data.realAccount : undefined;
                        this.queryData.demoAccount = data.demoAccount ? data.demoAccount : undefined;
                        this.queryData.fromTime = data.timeRangeStart ? DateUtil.formatDate(data.timeRangeStart, "yyyy-MM-dd hh:mm:ss") : undefined;
                        this.queryData.toTime = data.timeRangeEnd ? DateUtil.formatDate(data.timeRangeEnd, "yyyy-MM-dd hh:mm:ss") : undefined;
                        this.queryData.channels = data.channel ? this.parseChannelValue(data.channel) : undefined;
                        this.queryData.contactMethod = data.contactMethod ? data.contactMethod : 0;
                        this.queryData.hasImg = data.hasImg ? this.parseNumber2Boolean(data.hasImg) : undefined;
                        this.queryData.isValid = data.isValid ? this.parseNumber2Boolean(data.isValid) : undefined; 
                        this.queryData.isTestingAccount = data.isTestingAccount ? this.parseNumber2Boolean(data.isTestingAccount) : undefined; 
                        this.queryData.platform = data.platform ? data.platform : 0;
                    }
                    // console.log("queryData", this.queryData);
                    this.$refs.childTable.defaultQueryData(this.queryData);
                } else if(window.$t('mis.feedback.queryForm.button.export') == clickName) {
                    this.exportFeedback(clickName, "export");
                } else if(window.$t('mis.feedback.queryForm.button.download') == clickName) {
                    this.exportFeedback(clickName, "encrypted");
                }
            },
            btnclick(clickName, row){
                if("view" == clickName) {
                    // Set dialog data
                    this.getFeedbackDetail(row.id);
                    // this.$set(this.dialogData[0], "value", row.score);
                    // this.$set(this.dialogData[1], "value", this.parseNpsType(row.types));
                    // console.log("dialogData", this.dialogData);
                    this.$refs.childDialog.show();
                }
                if("validate" == clickName) {
                    this.validateFeedback(window.$t('mis.feedback.table.button.validate'), row);
                }
            },
            getFeedbackDetail(id) {
                let url = URL.feedback.detail + "/" + id;
                this.$axios.get(url).then(res=> {
                    if (res.code == 0 && res.result != undefined) {
                        this.$set(this.dialogData[0], "value", res.result.content);
                        let images = [];
                        if (res.result.images && res.result.images.length > 0) {
                            images = res.result.images.map(el => {
                                let urls = [];
                                urls.push(el.url);
                                urls.push(el.thumbnail);
                                return {
                                    ...el,
                                    urls: urls
                                }
                            });
                        }
                        this.$set(this.dialogData[1], "value", images);
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
            validateFeedback(clickName, row) {
                console.log('Validating feedback:', row);
                let replacement = !row['isValid'] ? window.$t('mis.feedback.table.button.valid') :  window.$t('mis.feedback.table.button.invalid');
                let confirmMessage = window.$t('mis.feedback.table.messageBox.message').replace('{status}', replacement );
                this.$confirm(confirmMessage, window.$t('mis.feedback.table.messageBox.title'), {
                confirmButtonText: window.$t('mis.feedback.table.messageBox.confirm'),
                cancelButtonText: window.$t('mis.feedback.table.messageBox.cancel'),
                type: 'warning'
                }).then(() => {
                    this.$axios.get(URL.feedback.validate + "/"+row['id']+"?isValid="+!row['isValid']).then(res => {
                    if (res.code == 0) {
                        let result = res.result;
                        if (result) {
                            this.$message.success(res.message);
                            this.$refs.childTable.defaultQueryData();  
                        } else {
                            this.$message.error(res.message);
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: window.$t('mis.feedback.table.messageBox.cancleMessage') + clickName
                    });          
                });
            },
            exportFeedback(clickName, action) {
                this.$confirm(window.$t('mis.feedback.queryForm.messageBox.message'), window.$t('mis.feedback.queryForm.messageBox.title'), {
                confirmButtonText: window.$t('mis.feedback.queryForm.messageBox.confirm'),
                cancelButtonText: window.$t('mis.feedback.queryForm.messageBox.cancel'),
                type: 'warning'
                }).then(() => {
                    this.requestExcel(action);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: window.$t('mis.feedback.queryForm.messageBox.cancleMessage') + clickName
                    });          
                });
            },
            requestExcel(action) {
                let {pageSize, pageNum, ...params} = this.queryData;
                let url = URL.feedback.export;
                if (action == 'encrypted') url = URL.feedback.download;
                this.$axios.post(url, JSON.stringify(params), requestOptions).then((res) => {
                    const data = res.data == null ? res : res.data;
                    const blob =new Blob([data], { type: 'application/vnd.ms-excel' });
                    
                    const href = window.URL.createObjectURL(blob);
                    
                    const anchorElement = document.createElement('a');
                    
                    anchorElement.href = href;

                    // 1) Get the value of content-disposition header
                    const contentDisposition = res.headers == null ? "" : res.headers['Content-Disposition'];
                    // console.log('contentDisposition: ', contentDisposition);

                    // 2) set the fileName variable to the default value
                    let fileName = "feedback_"+action+"_excel_"+ Date.now() +".xlsx";

                    // 3) if the header is set, extract the filename
                    if (contentDisposition) {
                        const fileNameMatch =
                        contentDisposition.match(/filename="(.+)"/);
                        // console.log('fileNameMatch', fileNameMatch);
                        if (fileNameMatch.length === 2) {
                        fileName = fileNameMatch[1];
                        }
                    }

                    anchorElement.download = fileName;

                    document.body.appendChild(anchorElement);
                    anchorElement.click();

                    document.body.removeChild(anchorElement);
                    window.URL.revokeObjectURL(href);    
                }).catch(err => {
                    console.error(err);
                })
            },
            getMetaData() {
                this.$axios.get(URL.appProduct.metaData + "?type=channel").then(res => {
                    if (res.code == 0) {
                        let responseData = res.result.list ? res.result.list : res.result;
                        if (responseData) {
                             // Handle channel data
                             let channelData = responseData.channel;
                            channelOptionList = channelData.map(({channelKey, channelName, channelApps}) => ({value: channelKey, label: channelName, children: channelApps}))
                            channelOptionList = channelOptionList.map(item => {
                                return {
                                    ...item,
                                    children: item.children.map(({id, name}) => ({value: id, label: name}))
                                }});
                            channelOptionList.push.apply(channelOptionList, fixedChannelOptions);
                            // console.log("Channel Option List: ", channelOptionList);
                            channelAppMasterList = channelData.flatMap(item => item.channelApps);
                            channelAppMasterList.push.apply(channelAppMasterList, fixedChannelMasterList);
                            // console.log("Channel Option Master List: ", channelAppMasterList);
                            this.$set(this.formData.cols, 4, {
                                title: window.$t('mis.feedback.queryForm.label.channel'), field: 'channel', type: 15, optionList: channelOptionList, props: cascaderProps, 
                                placeholder: window.$t("mis.feedback.queryForm.option.channel.placehoder"), data: []
                            });
                            
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            parseChannelValue(channels) {
                if (channels.length > 0) {
                    let channel = channels.split(',');
                    channel = channel.map(id => {
                        let selectedChannel = channelAppMasterList.filter(e => e.id == id)[0];
                        return selectedChannel.channel + "/" + selectedChannel.name;
                    });
                    return channel;
                }
                return [];
            },
            parseNumber2Boolean(number) {
                if (number === 0) return undefined;
                if (number === 1) return true;
                if (number === 2) return false; 
            },
        },
        data () {
            
            return {
                queryData:{
                    // accountType: 0,
                    // realAccount:"",
                    // demoAccount: "",
                    // fromTime: "",
                    // toTime: "",
                    // channel: "",
                    // contactMethod: 0,
                    // hasImg: true,
                    // isValid: true,
                    // platform: 0
                },
                dialogTitle: window.$t('mis.feedback.modal.title'),
                dialogData: [
                    {label: window.$t('mis.feedback.modal.label.content'), value: 0, type: 'text'},
                    {label: window.$t('mis.feedback.modal.label.image'), value: [], type: 'image'},
                ],
                /*form查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                    { title: window.$t('mis.feedback.queryForm.label.accountType'), field: 'accountType', type: 2, optionList: accountTypeOptionList, placeholder: accountTypeOptionList[0].value},
                    { title: window.$t('mis.feedback.queryForm.label.realAccount'), field: 'realAccount'},
                    { title: window.$t('mis.feedback.queryForm.label.demoAccount'), field: 'demoAccount'},
                    { title: window.$t('mis.feedback.queryForm.label.createdTime'), field: 'timeRange', type: 6},
                    { title: window.$t('mis.feedback.queryForm.label.channel'), field: 'channels', type: 2, optionList: []},
                    { title: window.$t('mis.feedback.queryForm.label.contact'), field: 'contactMethod', type: 2, optionList: contactOptionList, placeholder: contactOptionList[0].value},
                    { title: window.$t('mis.feedback.queryForm.label.hasImage'), field: 'hasImg', type: 2, optionList: imageOptionList, placeholder: imageOptionList[0].value},
                    { title: window.$t('mis.feedback.queryForm.label.validateStatus'), field: 'isValid', type: 2, optionList: validateStatusOptionList, placeholder: validateStatusOptionList[0].value},
                    { title: window.$t('mis.feedback.queryForm.label.accountStatus'), field: 'isTestingAccount', type: 2, optionList: accountStatusOptionList, placeholder: accountStatusOptionList[0].value},
                    { title: window.$t('mis.feedback.queryForm.label.platform'), field: 'platform', type: 2, optionList: platformOptionList, placeholder: platformOptionList[0].value},
                    { click: window.$t('mis.feedback.queryForm.button.query'), auth: "mis:app:feedback:query"},
                    { click: window.$t('mis.feedback.queryForm.button.download'), auth: "mis:app:feedback:download"},
                    { click: window.$t('mis.feedback.queryForm.button.export'), auth: "mis:app:feedback:export"}
                  ]
                },
                /*table生成*/
                pageData: {
                    method: "post",
                    fieldTotal: "recordsFiltered",
                    fieldData: "data",
                    isShow: false,
                    queryUrl: URL.feedback.query, //请求路径和参数
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.feedback.table.header.feedbackNo'), field: 'feedbackNo'},
                        { title: window.$t('mis.feedback.table.header.realAccount'), field: 'realAccount'},
                        { title: window.$t('mis.feedback.table.header.demoAccount'), field: 'demoAccount'},
                        { title: window.$t('mis.feedback.table.header.phone'), field: 'phone'},
                        { title: window.$t('mis.feedback.table.header.wechat'), field: 'wechat'},
                        { title: window.$t('mis.feedback.table.header.feedbackType'), field: 'feedbackType', render(val, row) {
                            if (val.name) return val.name;
                            return '';
                        }},
                        { title: window.$t('mis.feedback.table.header.description'), field: 'description'},
                        { title: window.$t('mis.feedback.table.header.createdTime'), field: 'createdTime'},
                        { title: window.$t('mis.feedback.table.header.platform'), field: 'platform', render(val, row) {
                            if (val == null) return "";
                            if (val == 1) return window.$t('mis.feedback.queryForm.option.platform.app');
                            if (val == 2) return window.$t('mis.feedback.queryForm.option.platform.mobile');
                            if (val == 3) return window.$t('mis.feedback.queryForm.option.platform.pc');
                        }},
                        { title: window.$t('mis.feedback.table.header.channel'), field: 'channel'},
                        { title: window.$t('mis.feedback.table.header.appVersion'), field: 'appVersion'},
                        { title: window.$t('mis.feedback.table.header.hasImage'), field: 'hasImg', render(val, row) {
                            if (val) return window.$t('mis.feedback.table.value.true');
                            else return window.$t('mis.feedback.table.value.false');
                        }},
                        { title: window.$t('mis.feedback.table.header.isTestingAccount'), field: 'isTestingAccount', render(val, row) {
                            if (val) return window.$t('mis.feedback.table.value.true');
                            else return window.$t('mis.feedback.table.value.false');
                        }},
                        { title: window.$t('mis.feedback.table.header.operation'), btnClick: [
                            {name: window.$t('mis.feedback.table.button.view'), click:"view",type:"primary", icon: "el-icon-view", auth:"mis:app:feedback:view"},
                            
                            {name: window.$t('mis.feedback.table.button.valid'), click:"validate", type:'success', icon:'el-icon-check',auth:"mis:app:feedback:validate", hidden (val, row){
                                if (row['isValid'] == true) return false;
                                else return true;
                            }},
                            {name: window.$t('mis.feedback.table.button.invalid'), click:"validate", type:'warning', icon:'el-icon-close',auth:"mis:app:feedback:validate", hidden (val, row){
                                if (row['isValid'] == true) return true;
                                else return false;
                            }}
                        ]}
                    ]
                }
            }
        },
        created () {
            this.getMetaData();
        }
    }
</script>
